module.exports = __webpack_public_path__ + "img/Banner-GirlSmartThermostat-dwnszd.fcf67aa0.jpg";